<template>
  <div :state="sendDelivery">
    <b-overlay :show="chargingDelivery" rounded="sm">
      <div class="delivery" :aria-hidden="chargingDelivery ? 'true' : null">
        <h6 style="color: #e53935">
          <b><i class="fa fa-map-marker-alt"></i> Delivery</b>
        </h6>

        <hr />

        <div class="delivery__cities">
          <b-form-input
            v-model="pickupAndDelivery.zip_to"
            onClick="this.select();"
            v-on:keyup.enter="addZipTo"
            placeholder="Zip to"
            size="sm"
            list="zip_to"
            class="delivery__cities--input"
            autocomplete="off"
          ></b-form-input>

          <datalist id="zip_to">
            <option v-for="(zipto, index) in zip_to" v-bind:key="index">{{
              zipto
            }}</option>
          </datalist>

          <b-form-input
            v-model="pickupAndDelivery.city_to"
            onClick="this.select();"
            v-on:keyup.enter="addCityTo"
            placeholder="City to"
            size="sm"
            list="city_to"
            class="delivery__cities--input"
            autocomplete="off"
          ></b-form-input>

          <datalist id="city_to">
            <option v-for="(cityto, index) in city_to" v-bind:key="index">{{
              cityto
            }}</option>
          </datalist>
        </div>

        <hr />

        <div
          class="delivery__cities"
          v-if="
            actualQueue == 'drayage' ||
              selectedModeName == 'Drayage' ||
              actualQueue == 'tempcontrol'
          "
          :key="rendercitiesInfo"
        >
          <span><b>Select city for Xenon:</b></span>
          <b-form-input
            v-model="xenonInfoCitySelected"
            placeholder="Select City"
            size="sm"
            list="xenon-info-city"
            class="delivery__cities--input"
            autocomplete="off"
          ></b-form-input>

          <datalist id="xenon-info-city">
            <option
              v-for="(xenonCity, index) in xenonCities"
              v-bind:key="index"
              >{{ xenonCity.name }}</option
            >
          </datalist>
        </div>

        <hr
          v-if="
            actualQueue == 'drayage' ||
              selectedModeName == 'Drayage' ||
              actualQueue == 'tempcontrol'
          "
        />

        <AccessorialsDelivery
          v-model="pickupAndDelivery.accessorials"
          :tripNumber="tripNumber"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccessorialsDelivery from "../LTL/AccessorialsDelivery";
import { setZipCode, setCity } from "@/mixins/pickupAndDelivery/standardizers";
export default {
  name: "Delivery",
  components: {
    AccessorialsDelivery
  },
  props: {
    tripNumber: Number,
    zipCodes: Array,
    cities: Array
  },
  data() {
    return {
      pickupAndDelivery: {
        zip_to: "",
        city_to: "",
        country_to: "",
        accessorials: null
      },
      zip_to: [],
      city_to: [],
      chargingDelivery: false,
      haulInformation: null,
      actualQueue: null,
      selectedModeName: null,
      xenonInfoCitySelected: null,
      xenonCities: null,
      rendercitiesInfo: 0
    };
  },
  computed: {
    ...mapGetters("quotes/quote", ["showSelectedMode"]),
    ...mapGetters("standardize", ["showInfoCityTo"]),
    sendDelivery() {
      return this.$emit("input", this.pickupAndDelivery);
    }
  },
  watch: {
    showSelectedMode(value) {
      this.selectedModeName = value?.name;
      this.getXenonInfoCities(this.pickupAndDelivery.zip_to);
    },
    xenonInfoCitySelected(value) {
      if (value) {
        for (let xenonCity of this.xenonCities) {
          if (value == xenonCity.name) {
            this.$store.commit("quotes/xenon/setXenonCityInfo", xenonCity);
            break;
          }
        }
      }
    },
    showInfoCityTo(value) {
      if (
        (this.showSelectedMode && this.showSelectedMode.name == "Drayage") ||
        this.actualQueue == "drayage" ||
        this.actualQueue == "tempcontrol"
      ) {
        if (
          (value.arrayZipCode && value.exists) ||
          (value.arrayCity && value.zipCodeSelected !== "NOT ACCEPTABLE")
        ) {
          let cityTo = value.zipCodeSelected
            ? value.zipCodeSelected
            : this.pickupAndDelivery.zip_to;
          this.getXenonInfoCities(cityTo);
        }
      }
    }
  },
  async created() {
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    this.zip_to = this.zipCodes;
    this.city_to = this.cities;
    if (
      this.$store.getters["quotes/quote/showQuoteById"].haul[
        this.tripNumber - 1
      ]
    ) {
      if (this.haulInformation[this.tripNumber - 1].zip_to != null) {
        this.pickupAndDelivery.zip_to = this.haulInformation[
          this.tripNumber - 1
        ].zip_to;
      }
      if (
        this.haulInformation[this.tripNumber - 1].city_to != null &&
        this.haulInformation[this.tripNumber - 1].city_to != "" &&
        this.haulInformation[this.tripNumber - 1].state_to != null &&
        this.haulInformation[this.tripNumber - 1].state_to != ""
      ) {
        this.pickupAndDelivery.city_to =
          this.haulInformation[this.tripNumber - 1].city_to +
          "," +
          this.haulInformation[this.tripNumber - 1].state_to;
      }
      let responseZip;
      if (
        this.pickupAndDelivery.zip_to != "" &&
        this.pickupAndDelivery.city_to == ""
      ) {
        this.chargingDelivery = true;
        responseZip = await this.$store.dispatch(
          "standardize/standardizeZip",
          this.pickupAndDelivery.zip_to
        );
        this.chargingDelivery = false;
        if (responseZip.status == 200) {
          if (responseZip.data[0][1] != "Not Acceptable") {
            this.pickupAndDelivery.city_to = responseZip.data[0][1];
            this.updateDelivery();
            if (!this.city_to.includes(this.pickupAndDelivery.city_to)) {
              this.city_to.push(responseZip.data[0][1]);
            }
          }
        }
      }
      let responseCity;
      if (
        this.pickupAndDelivery.city_to != "" &&
        this.pickupAndDelivery.zip_to == ""
      ) {
        this.chargingDelivery = true;
        responseCity = await this.$store.dispatch(
          "standardize/standardizeCity",
          this.pickupAndDelivery.city_to
        );
        this.chargingDelivery = false;
        if (responseCity.status == 200) {
          if (responseCity.data[0][0] != "Not Acceptable") {
            this.pickupAndDelivery.zip_to = responseCity.data[0][0];
            this.updateDelivery();
            if (!this.zip_to.includes(this.pickupAndDelivery.zip_to)) {
              this.zip_to.push(responseCity.data[0][0]);
            }
          }
        }
      }
    }
    this.actualQueue = localStorage.getItem("actual-queue");
  },
  methods: {
    async confirmationAlert(first) {
      return await this.swal({
        title: "Warning!",
        text: `Do you want to keep ${first}?`,
        icon: "warning",
        buttons: ["Don't keep", "Keep"],
        dangerMode: false
      }).then(willDelete => {
        if (willDelete) {
          return false;
        } else {
          return true;
        }
      });
    },
    async addZipTo() {
      if (this.pickupAndDelivery.zip_to.length == 1) {
        this.pickupAndDelivery.zip_to = "";
        this.swal({
          title: "Warning!",
          text: `zip code not allowed!`,
          icon: "warning",
          dangerMode: false
        });
      }
      if (
        this.pickupAndDelivery.zip_to != null &&
        this.pickupAndDelivery.zip_to != "" &&
        this.pickupAndDelivery.zip_to.length > 1
      ) {
        this.chargingDelivery = true;
        let response = await setZipCode(
          this.pickupAndDelivery.zip_to.replaceAll(" ", ""),
          this.city_to,
          this.zip_to
        );
        this.$store.commit("standardize/setInfoCityTo", response);
        if (response.exists) {
          this.pickupAndDelivery.zip_to = response.zip_code_response
            ? response.zip_code_response
            : this.pickupAndDelivery.zip_to;
          this.zip_to = response.arrayZipCode;
          this.city_to = response.city;
          this.pickupAndDelivery.city_to = response.city_selected;
          this.pickupAndDelivery.country_to = response?.country_response;
          this.updateDelivery();
        } else {
          if (response.cancel) {
            this.pickupAndDelivery.zip_to = null;
          } else {
            this.zip_to = response.arrayZipCode;
            this.updateDelivery();
          }
        }
      }
      this.chargingDelivery = false;
      document.activeElement.blur();
    },
    async addCityTo() {
      if (this.pickupAndDelivery.city_to.length == 1) {
        this.pickupAndDelivery.city_to = "";
        this.swal({
          title: "Warning!",
          text: `City not allowed!`,
          icon: "warning",
          dangerMode: false
        });
      }
      if (
        this.pickupAndDelivery.city_to != null &&
        this.pickupAndDelivery.city_to != "" &&
        this.pickupAndDelivery.city_to.length > 1
      ) {
        this.chargingDelivery = true;
        let response = await setCity(
          this.pickupAndDelivery.city_to,
          this.zip_to,
          this.city_to
        );
        this.$store.commit("standardize/setInfoCityTo", response);
        if (response.exists) {
          this.city_to = response.arrayCity;
          this.zip_to = response.zipCode;
          if (
            this.pickupAndDelivery.zip_to != null &&
            this.pickupAndDelivery.zip_to != ""
          ) {
            if (this.pickupAndDelivery.zip_to != response.zipCodeSelected) {
              let confirmation = await this.confirmationAlert(
                this.pickupAndDelivery.zip_to
              );
              if (confirmation) {
                this.pickupAndDelivery.zip_to = response.zipCodeSelected;
              }
            }
          } else {
            this.pickupAndDelivery.zip_to = response.zipCodeSelected;
          }
          this.pickupAndDelivery.city_to = response.citySelected;
          this.updateDelivery();
        } else {
          if (response.cancel) {
            this.pickupAndDelivery.city_to = null;
          } else {
            this.city_to = response.arrayCity;
            this.updateDelivery();
          }
        }
      }
      this.chargingDelivery = false;
      document.activeElement.blur();
    },
    async updateDelivery() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      if (
        this.pickupAndDelivery.zip_to != null &&
        this.pickupAndDelivery.zip_to != ""
      ) {
        info.payload.zip_to = this.pickupAndDelivery.zip_to;
      }
      if (
        this.pickupAndDelivery.city_to != null &&
        this.pickupAndDelivery.city_to != "" &&
        this.pickupAndDelivery.city_to.includes(",")
      ) {
        info.payload.city_to = this.pickupAndDelivery.city_to.split(",")[0];
        info.payload.state_to = this.pickupAndDelivery.city_to
          .split(",")[1]
          .replace(" ", "");
        info.payload.country_to = this.pickupAndDelivery.country_to;
      }
      await this.$store.dispatch("quotes/haul/updateHaul", info);
    },
    async getXenonInfoCities(zipTo) {
      let citiesInfo = {};
      citiesInfo.query = zipTo;
      citiesInfo.type = "zip";
      let response = await this.$store.dispatch(
        "quotes/xenon/getCities",
        citiesInfo
      );
      if (response.status == 200) {
        this.xenonCities = response.data;
      }
      let cityTo = this.pickupAndDelivery.city_to
        .replaceAll(" ", "")
        .toUpperCase();
      for (let xenonCity of this.xenonCities) {
        if (cityTo == xenonCity.name.replaceAll(" ", "")) {
          this.xenonInfoCitySelected = xenonCity.name;
          this.$store.commit("quotes/xenon/setXenonCityInfo", xenonCity);
          break;
        } else {
          this.xenonInfoCitySelected = this.xenonCities[0].name;
          this.$store.commit(
            "quotes/xenon/setXenonCityInfo",
            this.xenonCities[0]
          );
        }
      }
      this.rendercitiesInfo++;
    }
  }
};
</script>

<style lang="scss" scoped>
.delivery {
  @include pickup-delivery;
}
</style>
